import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryFish',
  templateUrl: './SalaryFish.component.html',
  styleUrls: ['./SalaryFish.component.scss']
})
export class SalaryFishComponent implements OnInit {

  @Output() outter_Salary= new EventEmitter<number>();
  @Input() innerPersonId:number=0
  @Input() innerYear:number=0
  @Input() innerMonth:number=0

  Token:String=""
  Procssing:boolean=false
  DataList_Salary:any

  constructor(
    private Salary_Service:SalaryService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.ReadData_Salary()
  }

  ReadData_Salary(){
    this.Procssing=true
    this.Salary_Service.GetSalaryMonthFish(this.Token,this.innerYear,this.innerMonth,this.innerPersonId).subscribe(
      data=>{
        this.DataList_Salary=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  calcKosorat(item:any){
    return Number(item['maliatPay'])+Number(item['bimehKargar'])
  }


  calcTahahol(item:any){
    if(Number(item['salaryRecord']['tahahol'])>0)
      return "Married"  
    else 
      return "Single"  
  }

  onBack(){
    this.outter_Salary.emit(-1);
  }

}
